import {MathUtils} from 'three';

/** Continuous pose drivers from motion, shared by local and replicated avatars.
 * Authored silhouettes carry the gesture; existing rigid springs supply detail. */
export class CrystalWingAirframe {
  fast=0;
  descent=0;
  flare=0;
  bank=0;
  readonly sweep=new Float64Array(3);
  readonly opening=new Float64Array(3);
  private speed=0;
  private path=0;
  private seeded=false;
  update(dt:number,horizontal:number,vertical:number,turn:number,active:boolean):void{
    if(!Number.isFinite(dt)||dt<=0)return;
    const finite=(v:number)=>Number.isFinite(v)?v:0;
    const speed=Math.hypot(finite(horizontal),finite(vertical));
    const path=Math.atan2(finite(vertical),Math.max(.1,Math.abs(finite(horizontal))));
    // Rates are measured from filtered travel, not camera aim or animation bones.
    // Reset inactive samples so deployment never looks like a violent pull-up.
    const reset=!this.seeded||!active||dt>.2;
    if(reset){this.speed=speed;this.path=path;}
    const ease=1-Math.exp(-7*dt);
    const speedRate=reset?0:(speed-this.speed)*ease/dt;
    const pitchRate=reset?0:(path-this.path)*ease/dt;
    this.speed+=(speed-this.speed)*ease;this.path+=(path-this.path)*ease;
    const fast=active?MathUtils.smoothstep(this.speed,20,52):0;
    const descent=active?MathUtils.smoothstep(-this.path,.24,1.20):0;
    const opening=active?MathUtils.clamp(
      Math.max(0,pitchRate)*.52*MathUtils.smoothstep(speed,9,30)
      +MathUtils.smoothstep(-speedRate,3,16)*.7
      +MathUtils.smoothstep(this.path,.08,.65)*.24,0,1):0;
    this.fast+=(fast-this.fast)*(1-Math.exp(-5*dt));
    this.descent+=(descent-this.descent)*(1-Math.exp(-6*dt));
    this.flare+=(opening-this.flare)*(1-Math.exp(-(opening>this.flare?10:3.5)*dt));
    // A coordinated whole-fan roll, in addition to individual feathering.
    const bank=active?MathUtils.clamp(finite(turn)/1.5,-1,1)*(.22+.20*MathUtils.smoothstep(speed,10,38)):0;
    this.bank+=MathUtils.clamp((bank-this.bank)*(1-Math.exp(-5*dt)),-dt,dt);
    for(let row=0;row<3;row++){
      const sweep=active?MathUtils.clamp(this.fast*.75+this.descent*.60,0,1)*(1-this.flare*.70):0;
      this.sweep[row]+=(sweep-this.sweep[row])*(1-Math.exp(-(10-row*2)*dt));
      this.opening[row]+=(this.flare-this.opening[row])*(1-Math.exp(-(14-row*3)*dt));
    }
    this.seeded=true;
  }
}
